import { Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { MatPaginator, MatTableDataSource, MatSort, MatSnackBar } from '@angular/material';
import * as FileSaver from 'file-saver';
import { UtilsService } from '../../shared/utils-service';
import { Router } from '@angular/router';

@Component({
	selector: 'app-activity-history',
	templateUrl: './activity-history.component.html',
	styleUrls: ['./activity-history.component.css']
})
export class ActivityHistoryComponent implements OnInit {
	private loader: boolean = false;
	private showAdvanced: boolean;
	private listLength = 0;
	private searchById: boolean;
	private searchUrl: string = this.utils.url + '/auditTrail/searchActivityHistory';
	private exporturl: string = this.utils.url + '/auditTrail/exportActivityHistory?userId=';
	private result: any = [];
	private list: any = [];
	dataSource: any = [];
	private range = 0;
	search: any = {};
	displayedColumns: any = [];
	arStatusMap: any = { 'A': 'Add', 'E': 'Edit', 'D': 'Delete' };
	private updated: boolean;

	//*ngIf="result.filteredData.length"
	private loggedInUser: any = {};
	constructor(private http: Http, private utils: UtilsService, private router: Router, private matSnackBar: MatSnackBar) {
		this.loggedInUser = this.utils._checkSession({ 'page': 'telco-audit-trail' });
		this.showAdvanced = true;
		this.updated = false;
	}

	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild(MatSort) sort: MatSort;

	ngOnInit() {
		this.displayedColumns = ['icLcno', 'brno', 'nicBrno', 'name', 'chgUserId', 'chgDate', 'chgCode'];
	}

	resetData() {
		this.search = {};
		this.list = [];
		this.result = [];
		this.listLength = 0;
	}

	export() {
  	/*this.http.get(this.exporturl+this.loggedInUser.userId).subscribe(data => {
  var mediaType = 'application/csv';
                    var blob = new Blob([data['_body']], {type: mediaType});
                    var filename = 'ActivityHistory.csv';
                    FileSaver.saveAs(blob, filename);
},
		error => {
			// this.matSnackBar.open('Something went wrong!! Please try after some time.', 'Close', {
   //    			duration: 5000,
   //  		});

   			this.utils.notify('Something went wrong!! Please try after some time.');
		});*/
		// console.log(this.list, 'listttttttttttttt');
		this.utils.exportCSV(this.list, 'ActivityHistory.csv', this.displayedColumns);
	}

	searchData(e, page) {
		this.listLength = 0;
		this.range = 0;
		if (this.search.userId) {
			var usr = this.search.userId;
		} else {
			usr = this.loggedInUser.userId;
		}
		var headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('userId', this.loggedInUser.userId);
		headers.append('token', this.loggedInUser.token);
		this.displayedColumns = ['icLcno', 'brno', 'nicBrno', 'name', 'chgUserId', 'chgDate', 'chgCode'];

		let data = JSON.stringify({
			"userId": usr,
			"icNo": this.search.icNo,
			"newIcNo": this.search.newIcNo,
			"brNo": this.search.brNo,
			"name": this.search.name,
			"accountNo": this.search.accountNo,
			"showReportAs": this.search.showReportAs,
			"lastUpdateFrom": this.utils.dateToDB(this.search.lastUpdateFrom),
			"lastUpdateTo": this.utils.dateToDB(this.search.lastUpdateTo),
			"createdBy": "",
			"changedBy": "",
			"listOfRecord": "",
			"branch": "",
			"actionPerformed": "",
			"paginationAttribute":
			{
				"totalRecordCount": "0",
				"recordRangeFrom": this.range,
				"recordRangeTo": "10"
			}
		});
		//console.log(data);
		if (this.search.icNo != undefined || this.search.newIcNo != undefined || this.search.brNo != undefined || this.search.name != undefined || this.search.accountNo != undefined || this.search.lastUpdateFrom != undefined || this.search.lastUpdateTo != undefined) {
			if (this.search.icNo != "" || this.search.newIcNo != "" || this.search.brNo != "" || this.search.name != "" || this.search.accountNo != "" || this.search.lastUpdateFrom != "" || this.search.lastUpdateTo != "") {
				this.loader = true;
				this.http.post(this.searchUrl, data, { headers: headers }).subscribe(data => {
					this.loader = false;
					let json = JSON.parse(data['_body']);
					//console.log(this.list);
					if (json['blackLogList'] == null) {
						var message = json['ddmfResponseStatus'].responseStatusMessage;
						this.utils.notify(message);
						this.result = [];
						this.list = [];
						this.result.sort = this.sort;
					} else {
						this.listLength = json['paginationAttribute'].totalRecordCount;
						this.list = json['blackLogList'];
						this.result = new MatTableDataSource(json['blackLogList']);
						this.result.sort = this.sort;
					}
				},
					error => {
						this.loader = false;
						this.utils.notify('Something went wrong!! Please try after some time.');
					})
			}
			else {
				this.utils.notify('Please enter the fields.');
			}
		}
		else {
			this.utils.notify('Please enter the fields.');
		}
		//console.log(this.list);
	}

	searchNextData(e, page) {
		if (this.search.userId) {
			var usr = this.search.userId;
		} else {
			usr = this.loggedInUser.userId;
		}
		if (page == "last") {
			this.range = (this.listLength-(this.listLength % 10));
		} else if ((this.range + 10) < this.listLength) {
			this.range = this.range + 10;
		}
		var headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('userId', this.loggedInUser.userId);
		headers.append('token', this.loggedInUser.token);
		this.displayedColumns = ['icLcno', 'brno', 'nicBrno', 'name', 'chgUserId', 'chgDate', 'chgCode'];

		let data = JSON.stringify({
			"userId": usr,
			"icNo": this.search.icNo,
			"newIcNo": this.search.newIcNo,
			"brNo": this.search.brNo,
			"name": this.search.name,
			"accountNo": this.search.accountNo,
			"showReportAs": this.search.showReportAs,
			"lastUpdateFrom": this.utils.dateToDB(this.search.lastUpdateFrom),
			"lastUpdateTo": this.utils.dateToDB(this.search.lastUpdateTo),
			"createdBy": "",
			"changedBy": "",
			"listOfRecord": "",
			"branch": "",
			"actionPerformed": "",
			"paginationAttribute":
			{
				"totalRecordCount": "0",
				"recordRangeFrom": this.range,
				"recordRangeTo": "10"
			}
		});
		//console.log(data);
		if (this.search.icNo != undefined || this.search.newIcNo != undefined || this.search.brNo != undefined || this.search.name != undefined || this.search.accountNo != undefined || this.search.lastUpdateFrom != undefined || this.search.lastUpdateTo != undefined) {
			if (this.search.icNo != "" || this.search.newIcNo != "" || this.search.brNo != "" || this.search.name != "" || this.search.accountNo != "" || this.search.lastUpdateFrom != "" || this.search.lastUpdateTo != "") {
				this.loader = true;
				this.http.post(this.searchUrl, data, { headers: headers }).subscribe(data => {
					this.loader = false;
					let json = JSON.parse(data['_body']);

					//console.log(this.list);
					if (json['blackLogList'] == null) {
						var message = json['ddmfResponseStatus'].responseStatusMessage;
						this.utils.notify(message);
						this.result = [];
						this.list = [];
						this.result.sort = this.sort;
					} else {
						this.listLength = json['paginationAttribute'].totalRecordCount;
						this.list = json['blackLogList'];
						this.result = new MatTableDataSource(json['blackLogList']);
						this.result.sort = this.sort;
					}
				},
					error => {
						this.loader = false;
						this.utils.notify('Something went wrong!! Please try after some time.');
					})
			}
			else {
				this.utils.notify('Please enter the fields.');
			}
		}
		else {
			this.utils.notify('Please enter the fields.');
		}
		//console.log(this.list);
	}

	searchPrevData(e, page) {
		if (this.search.userId) {
			var usr = this.search.userId;
		} else {
			usr = this.loggedInUser.userId;
		}


		if (page == "first") {
			this.range = 0;
		} else if (this.range > 0) {
			this.range = this.range - 10;
		}
		var headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('userId', this.loggedInUser.userId);
		headers.append('token', this.loggedInUser.token);
		this.displayedColumns = ['icLcno', 'brno', 'nicBrno', 'name', 'chgUserId', 'chgDate', 'chgCode'];

		let data = JSON.stringify({
			"userId": usr,
			"icNo": this.search.icNo,
			"newIcNo": this.search.newIcNo,
			"brNo": this.search.brNo,
			"name": this.search.name,
			"accountNo": this.search.accountNo,
			"showReportAs": this.search.showReportAs,
			"lastUpdateFrom": this.utils.dateToDB(this.search.lastUpdateFrom),
			"lastUpdateTo": this.utils.dateToDB(this.search.lastUpdateTo),
			"createdBy": "",
			"changedBy": "",
			"listOfRecord": "",
			"branch": "",
			"actionPerformed": "",
			"paginationAttribute":
			{
				"totalRecordCount": "0",
				"recordRangeFrom": this.range,
				"recordRangeTo": "10"
			}
		});
		//console.log(data);
		if (this.search.icNo != undefined || this.search.newIcNo != undefined || this.search.brNo != undefined || this.search.name != undefined || this.search.accountNo != undefined || this.search.lastUpdateFrom != undefined || this.search.lastUpdateTo != undefined) {
			if (this.search.icNo != "" || this.search.newIcNo != "" || this.search.brNo != "" || this.search.name != "" || this.search.accountNo != "" || this.search.lastUpdateFrom != "" || this.search.lastUpdateTo != "") {
				this.loader = true;
				this.http.post(this.searchUrl, data, { headers: headers }).subscribe(data => {
					this.loader = false;
					let json = JSON.parse(data['_body']);

					//console.log(this.list);
					if (json['blackLogList'] == null) {
						var message = json['ddmfResponseStatus'].responseStatusMessage;
						this.utils.notify(message);
						this.result = [];
						this.list = [];
						this.result.sort = this.sort;
					} else {
						this.listLength = json['paginationAttribute'].totalRecordCount;
						this.list = json['blackLogList'];
						this.result = new MatTableDataSource(json['blackLogList']);
						this.result.sort = this.sort;
					}
				},
					error => {
						this.loader = false;
						this.utils.notify('Something went wrong!! Please try after some time.');
					})
			}
			else {
				this.utils.notify('Please enter the fields.');
			}
		}
		else {
			this.utils.notify('Please enter the fields.');
		}
		//console.log(this.list);
	}

	goToURL(url) {
		this.router.navigateByUrl(url);
	}

	dateValidateLeapYear(e, val, field) {
		var res = val.split("-");
		if (val.length > '0' && val.length < '10') {
			this.utils.notify('Invalid Date Format');
			this.search[field] = "";
		}
		else if (res[0] == '0000') {
			this.utils.notify('Year is Invalid');
			this.search[field] = "";
		}
		else if (res[1] > '12' || res[1] == '00') {
			this.utils.notify('Month is Invalid');
			this.search[field] = "";
		}
		else if (res[2] > '31' || res[2] == '00') {
			this.utils.notify('Date is Invalid');
			this.search[field] = "";
		}
		else if (res[2] < '32' && res[2] != '00') {
			if (res[1] == '01' || res[1] == '03' || res[1] == '05' || res[1] == '07' || res[1] == '08' || res[1] == '10' || res[1] == '12') {
			}
			else {
				if (res[2] == '31') {
					this.utils.notify('Date is Invalid');
					this.search[field] = "";
				}
				else if (res[1] == '02') {
					if (((res[0] % 4 == 0) && (res[0] % 100 != 0)) || (res[0] % 400 == 0)) {
						if (res[2] > '29') {
							this.utils.notify('Date is Invalid');
							this.search[field] = "";
						}
					}
					else {
						if (res[2] > '28') {
							this.utils.notify('Date is Invalid');
							this.search[field] = "";
						}
					}
				}
			}
		}
	}

	onPaginateChange(e, page) {
		if (page == "next") {

		}
		else if (page == "back") {

		}
	}

	dateValidate(e, val, field) {
		if (e.charCode >= 48 && e.charCode <= 57) {
			//console.log(val.length);
			if (val.length == 4) {
				val = val + '-';
				//console.log(val);
				this.search[field] = val;
			} else if (val.length == 7) {
				val = val + '-';
				//console.log(val);
				this.search[field] = val;
			}
			//console.log(val, 'value', this.search[field], field);
		} else {
			e.preventDefault();
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/telco-audit-trail/activity-history/activity-history.component.ts